import { render, staticRenderFns } from "./PaymentTerms.vue?vue&type=template&id=7491058a&"
import script from "./PaymentTerms.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PaymentTerms.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7491058a')) {
      api.createRecord('7491058a', component.options)
    } else {
      api.reload('7491058a', component.options)
    }
    module.hot.accept("./PaymentTerms.vue?vue&type=template&id=7491058a&", function () {
      api.rerender('7491058a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/appointment/vrach/new/components/DoctorAppointmentForm/components/PaymentInfo/components/PaymentTerms.vue"
export default component.exports